'use strict';

import React, { memo } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

const DemandSmall = (props: DemandSmall.propTypes) => {
  return (
    <SvgIcon {...props} width="12" height="12" viewBox="0 0 12 12">
      <g transform="translate(0.074 -996)">
        <g transform="translate(-0.074 996)">
          <g fill="#fff" stroke={props.htmlColor} strokeWidth="1">
            <circle cx="6" cy="6" r="6" stroke="none" />
            <circle cx="6" cy="6" r="5.5" fill="none" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

DemandSmall.propTypes = {
  htmlColor: PropTypes.string,
};

DemandSmall.defaultProps = {
  htmlColor: '#F3A5A5',
};

export default memo(DemandSmall);
